import Vuetify from '@/plugins/vuetify';

export default {
  getPreFaturamento(state) {
    return state.preFaturamento;
  },
  getPreFaturamentoProcesso(state) {
    return state.preFaturamento.informacoesProcesso;
  },
  getPreFaturamentoComparativoProdutoInvoice(state) {
    return state.preFaturamento.comparativoProdutoInvoice;
  },
  getPreFaturamentoComparativoProdutoDI(state) {
    return state.preFaturamento.comparativoProdutoDI;
  },
  getPreFaturamentoCustosEmissaoNF(state) {
    return state.preFaturamento.custosEmissaoNF;
  },
  getPreFatramentoFinanceiroPagar(state) {
    return state.preFaturamento.financeiroPagar;
  },
  getPreFatramentoProdutosProcesso(state) {
    return state.preFaturamento.produtosProcesso;
  },
  getKeysInformacaoProcesso(state) {
    return state.colunasInformacaoProcesso;
  },
  getKeysTabelaFinanceiroPagar(state) {
    return state.colunasTabelaFinanceiroPagar.map((coluna) => ({
      ...coluna,
      value: coluna.value,
      text: Vuetify.framework.lang.t(`$vuetify.${coluna.i18n}`),
    }));
  },
  getKeysTabelaComparativoProdutosDI(state) {
    return state.colunasTabelaComparativoProdutosDI.map((coluna) => ({
      ...coluna,
      value: coluna.value,
      text: Vuetify.framework.lang.t(`$vuetify.${coluna.i18n}`),
    }));
  },
  getKeysTabelaComparativoProdutosInvoice(state) {
    return state.colunasTabelaComparativoProdutosInvoice.map((coluna) => ({
      ...coluna,
      value: coluna.value,
      text: Vuetify.framework.lang.t(`$vuetify.${coluna.i18n}`),
    }));
  },
  getKeysTabelaCustosEmissaoNF(state) {
    return state.colunasTabelaCustosEmissaoNF.map((coluna) => ({
      ...coluna,
      value: coluna.value,
      text: Vuetify.framework.lang.t(`$vuetify.${coluna.i18n}`),
    }));
  },
  getKeysTabelaProdutosProcesso(state) {
    return state.colunasTabelaProdutosProcesso.map((coluna) => ({
      ...coluna,
      value: coluna.value,
      text: coluna.i18n,
    }));
  },
  getKeysTabelaDocumentosGED(state) {
    return state.colunasTabelaDocumentosGED.map((coluna) => ({
      ...coluna,
      value: coluna.value,
      text: Vuetify.framework.lang.t(`$vuetify.${coluna.i18n}`),
    }));
  },
  possuiEventoConferenciaPreFaturamento(state) {
    return state.exibirConferenciaPreFaturamento;
  },
};
